import { FULL_SLOT } from 'shared/consts';

const FONT = {
	REGULAR: 'Open Sans',
	SUBFACE: 'PT Sans Narrow',
	// MEDIUM: 'Cervo Medium',
	// LIGHT: 'Cervo Light',
};

const TABLE = {
	FORMS: {
		CIRCLE: 'circle',
		SQUARE: 'square',
		QUAD: 'quad',
		RECT: 'rect',
	},
	ROTATIONS: {
		RECTH: 'recth',
		RECTV: 'rectv',
	},
	SIZES: {
		S: 's',
		M: 'm',
		L: 'l',
		XL: 'xl',
	},
	STATE: {
		FREE: 'free',
		WAITING: 'waiting',
		DELAY: 'delay',
		BUSY: 'busy',
		ENDING: 'ending',
	},
};

const SQUARE_ROTATION = {
	VERTICAL: 'rectv',
	HORIZONTAL: 'recth',
};

const SIZE_MATRIX: any = {
	CIRCLE: {
		S: [1, 2, 3, 4, 5, 6, 8],
		M: [2, 3, 4, 5, 6, 8],
		L: [2, 3, 4, 5, 6, 8],
		XL: [2, 3, 4, 5, 6, 8],
	},
	QUAD: {
		S: [2,4],
		M: [2,4],
		L: [2,4], // TODO двойка ламает стол
		// XL: [8,12],
	},
	SQUARE: {
		S: [2, 3, 4, 5, 6, 10],
		M: [4, 6, 10],
		L: [6, 8, 10],
		XL: [8, 10, 12, 24],
	},
	RECT: {
		S: [2, 3, 4, 5, 6, 7, 8],
		M: [2, 3, 4, 5, 6, 7, 8, 10],
		L: [2, 3, 4, 5, 6, 7, 8],
	}
};

const COLORS = {
	SEATS: {
		ACTIVE: '#808080',
		INACTIVE: '#E6E6E6',
	},
	BORDER: '#222222',
	SELECTED: '#2E9BEF',
	SELECTED_CONFLICT: FULL_SLOT,
	TABLE: {
		FREE: {
			BG: '#FFFFFF',
		},
		WAITING: {
			BG: '#F99FCD',
		},
		DELAY: {
			BG: '#FF45A5',
		},
		BUSY: {
			BG: '#FBA351',
		},
		BUSY_APPOINTED: {
			BG: '#B7CFFF',
		},
		ENDING: {
			BG: '#FBA351',
		},
		EXCEEDING: {
			BG: '#F75D61',
		},
    RELEVANT: {
      BG: '#c3e6cd',
    }
	},
	DIAGRAM: {
		DELAY: '#F75D61',
		BUSY: '#FFB36C',
		EXCEEDING: '#B7CFFF',
	},
};

export const DIAGRAM_STATE: any = {
	DELAY: COLORS.DIAGRAM.DELAY,
	BUSY: COLORS.DIAGRAM.BUSY,
	EXCEEDING: COLORS.DIAGRAM.EXCEEDING,
	FREE: '',
};

const STATUSES = {
	FREE: 'free',
	WAITING: 'waiting',
	DELAY: 'delay',
	BUSY: 'busy',
	ENDING: 'ending',
	EXCEEDING: 'exceeding',
  RELEVANT: 'relevant',
	//INACTIVE: 'inactive',

	// LINGER: 'linger',
	// LATE: 'late',
	// COME_SOON: 'comeSoon',
} as const;

export type TableStatusType = (typeof STATUSES)[keyof typeof STATUSES];
// const ICONS = {
// 	WAITING: 'waiting',
// 	DELAY: 'delay',
// 	BUSY: 'busy',
// 	ENDING: 'ending',
// 	INACTIVE: 'inactive',
// };

export const MODES = {
	EDITOR: 'editor',
	STATIC: 'static',
	SELECT: 'select',
};

export const GRID_QUAD = 10;
export const SEAT_SIZE = 5;

export const MAX_SCALE = 1.5;
export const MIN_SCALE = 0.5;
export const MAP_SCALES = [0.5, 0.75, 1, 1.25, 1.5];

export { FONT, TABLE, COLORS, STATUSES, SIZE_MATRIX, SQUARE_ROTATION };
